<template>
    <div id="inviteList">
        <my-header></my-header>
        <img src="../../assets/images/inviteList/banner.png" alt="" class="banner-image">
        <div class="main-container mainCon">
            <p class="location">您当前的位置：招标公告</p>
            <el-form class="invite-form" label-width="140px" ref="form" :model="form">
                <el-row>
                    <el-col :span="7">
                        <!-- <el-form-item label="招标类别：">
                            <el-select size="medium" v-model="form.categoryId">
                                <el-option label="全部" value=""></el-option>
                                <el-option v-for="t in labels" :key="t.id" :label="t.dictLabel" :value="t.dictValue">
                                </el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item label="招标分类：">
                            <el-input  v-model="form.categoryName"
                                readonly
                                autosize
                                clearable
                                @focus="chooseCategory()"
                                placeholder="招标分类">
                                <i v-if="form.categoryName"
                                    class="el-icon-circle-close el-input__icon"
                                    slot="suffix"
                                    @click="handleIconClick">
                                </i>
                                </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="招标公告：" >
                            <el-input size="medium" v-model="form.msgTitle" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3" :offset="1">
                        <el-button class="btn-theme" size="medium"  icon="el-icon-search" @click="searchMethod">搜索</el-button>
                    </el-col>
                </el-row>
            </el-form>
            <ul class="listContent" v-if="inviteListData.length">
                <li v-for="(item,index) in inviteListData" :key="index">
                   <div class="leftIndex">
                       <img :src='"../../assets/images/inviteList/0"+(index+1)+".png"' />
                   </div>
                    <div class="rightText">
                        <h3>
                            <el-tooltip :content="item.msgTitle" :disabled="item.msgTitle.length<30" effect="light">
                                <strong @click="toDetail(item)">{{ item.msgTitle }}</strong>
                            </el-tooltip>
                            <span>发布日期：{{ item.createDate }}</span>
                        </h3>
                        <!-- <p>招标类别：<span>{{ getCurType(item.bidCategoryId) }}</span></p> -->
                        <p>招标分类：<span>{{ item.bidCategoryName }}</span></p>
                    </div>
                </li>
            </ul>
            <p v-else class="noResults">没有搜索结果</p>
         <!--   prev-text="上一页"
            next-text="下一页"-->
            <el-pagination
                :page-size="pager.pageSize"
                @current-change="handleCurrentChange"
                :current-page="pager.pageNum"
                :total="pager.total"
                layout="total, prev, pager, next"
                background
            >
            </el-pagination>
            <select-category ref="selectCategory" @callback="selectedCategory" :categoryStatus="1"></select-category>
        </div>
        <my-footer></my-footer>
    </div>
</template>
<script type="text/babel">
    import MyHeader from '../common/Header.vue'
    import MyFooter from '../common/Footer.vue'
    export default {
        name: 'invite-list',
        data(){
            return {
                form: {
                    categoryId: '',
                    msgTitle: '',
                    categoryName:'',
                },
                inviteListData: [],//招标公告列表数据；
                pager:{
                    total: 0,
                    pageNum: 1,
                    pageSize: 8
                },
                labels: [],//
            }
        },
        components: {
            MyHeader,
            MyFooter
        },
        created(){
            this.$root.activeIndex = 'invite';
            this.getCurrentList(1);//获取初始化第一页数据；
            this.getType();//获取dict_label
        },
        methods:{
            handleIconClick(val){
                this.form.categoryId = '';
                this.form.categoryName = '';
            },
            chooseCategory(){
                this.$refs['selectCategory'].show();
            },
            selectedCategory(val){
                this.form.categoryId = val.id;
                this.form.categoryName = val.categoryName;
            },
            getType() {
                let _this = this;
                _this.$root.getHttp('v1/sysDict/public/getDictListByDictType?dictType=tender_type', function (res) {
                   _this.labels = res.data.data || [];
                });
            },
            getCurType(cagId){
                if(!this.labels.length) return;
                let text = '无';
                this.labels.forEach( item => {
                    if(item.dictValue == cagId){
                        text = item.dictLabel;
                    }
                })
                return text;
            },
            getCurrentList(type){
                let _this = this;
                let obj = {};
                if(type == 1){
                    obj = {
                        "bidCategoryId": '',
                        "msgTitle": '',
                        "pageFlag": 1,//1分页，0不分页
                        "pageNumber": _this.pager.pageNum,
                        "pageSize": _this.pager.pageSize,
                        "msgType": 23 //23 招标公告，34 中标公告
                    };
                } else if(type == 2) {
                    obj = {
                        "bidCategoryId": this.form.categoryId,
                        "msgTitle": this.form.msgTitle,
                        "pageFlag": 1,//1分页，0不分页
                        "pageNumber": _this.pager.pageNum,
                        "pageSize": _this.pager.pageSize,
                        "msgType": 23 //23 招标公告，34 中标公告
                    };
                }
                this.$root.postHttp('/v1/outerformflow/public/getBidList',obj,function (res) {
//                console.log('列表',res)
                    _this.pager.total = res.data.data.total;
                    _this.inviteListData = res.data.data.records || [];
                })
            },
            toDetail(val){//到详情页。
//              console.log(id)
                this.$router.push('/invite/listDetail/'+val.id);
            },
            handleCurrentChange (page) {//当前页
                this.pager.pageNum = page;
                this.getCurrentList(2);//获取当前页列表数据；
            },
            searchMethod(){//搜索列表
                this.getCurrentList(2);
            }
        }
    }
</script>
<style lang="scss">
    @import '../../assets/_var.scss';
    #inviteList {
        padding-top: 70px;
        & .head-top{
            background: #fff;
        }
        & .head-right {
            color: $--text-color-light;
            & .login {
                background: url('../../assets/images/topBar2/icon07.png') no-repeat 0 1px;
            }
            & .register {
                background: url('../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
            }
            & .line {
                background: $--text-color-light;
            }
            & .help {
                background: url('../../assets/images/topBar2/icon05.png') no-repeat;
            }
            & .standard {
                background: url('../../assets/images/topBar1/standard2.png') no-repeat 5px center / 16px 16px;
            }
            & .wechat {
                background: url('../../assets/images/topBar2/icon06.png') no-repeat;
            }
        }
        .banner-image {
            min-width: 1300px;
            height: 140px;
        }
        & .mainCon {
            margin-top: 15px;
            min-height: 60vh;
        }
        .location {
            padding-left: 15px;
            text-align: left;
            font-size: 12px;
            line-height: 42px;
            color: $--text-color-light;
            background: url('../../assets/images/inviteList/location.png') no-repeat left center;
        }
        .invite-form {
            background: $--primary-fill-color;
            .el-row {
                padding: 30px 0;
            }
            .el-form-item {
                margin: 0;
            }
            .btn-theme {
                background: $--primary-color;
                color: #ffffff;
            }
            .el-button:hover, .el-button:focus {
                background: #fae7eb;
            }
        }
        .listContent {
            margin-top: 30px;
            li {
                overflow: hidden;
                padding: 20px 0;
                border-bottom: 1px solid $--secondary-fill-color;
                .leftIndex {
                    float: left;
                    background-color: $--secondary-fill-color;
                    line-height: 80px;
                    text-align: center;
                    width: 80px;
                    color: $--primary-color;
                    img {
                        vertical-align: middle;
                    }
                }
                .rightText {
                    float: left;
                    width: 1090px;
                    margin-left: 30px;
                    h3 {
                        overflow: hidden;
                        line-height: 40px;
                        strong {
                            float: left;
                            max-width: 500px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            font-size: 16px;
                            color: $--text-color;
                            cursor: pointer;
                        }
                        strong:hover {
                            color: $--primary-color;
                            text-decoration: underline;
                        }
                        span {
                            float: right;
                            font-size: 14px;
                            font-weight: normal;
                            color: $--text-color-lighter;
                        }
                    }
                    p {
                        padding-left: 22px;
                        text-align: left;
                        color: $--text-color-lighter;
                        font-size: 14px;
                        line-height: 50px;
                        background: url('../../assets/images/inviteList/icon01.png') no-repeat left center;
                        span {
                            color: $--text-color-light;
                        }
                    }
                }
            }
        }
        .noResults {
            font-size: 16px;
            color: #999;
            margin: 50px;
        }
        .el-pagination {
            margin: 50px 0 70px;
            text-align: right;
        }
    }

</style>



// WEBPACK FOOTER //
// src/pages/invite/List.vue